var module = angular.module('octopusApp.projects');

import React from 'react';

var StepTemplateLogo = React.createClass({
    propTypes: {
        url: React.PropTypes.string.isRequired,
        resolveLink: React.PropTypes.func,
        size: React.PropTypes.string.isRequired,
        class: React.PropTypes.string,
        enableCacheBreaker: React.PropTypes.bool
    },
    getDefaultProps() {
        return {
            enableCacheBreaker : true
        }
    },
    // You might be wondering why we need to have this ugly hack here. TL;DR; eTags don't work reliably in all browsers.
    // Full story is here: https://trello.com/c/UDY5VW7x/343-perf-enable-client-side-browser-caching-of-project-and-tenant-logos
    applyCacheBreaker : function(url){
        var cacheBreaker = (Math.round(new Date().getTime() / 1000));
        return url + '?cb=' + cacheBreaker;
    },
    sizeToStyles(size){
        switch(size){
            case "xx-small": return { width: "24px", height: "24px", borderRadius: "1px"};
            case "x-small": return { width: "40px", height: "40px", borderRadius: "2px"};
            case "small": return { width: "50px", height: "50px", borderRadius: "2px"};
            case "medium": return { width: "70px", height: "70px", borderRadius: "2px"};
            case "large": return { width: "100px", height: "100px", borderRadius: "4px"};
            default: throw size + " is an unknown size";
        }
    },
    render : function() {
        var resolveLink = this.props.resolveLink || function(url) {return url};
        var url = resolveLink(this.props.url);
        url = this.props.enableCacheBreaker ? this.applyCacheBreaker(url) : url;

        var styles = this.sizeToStyles(this.props.size);
        return <img className={this.props.class + " step-template-logo"} style={styles} src={url} />;
    }
});

module.directive('stepTemplateLogo', function (reactDirective, octopusClient) {
    return reactDirective(StepTemplateLogo);
});

export default StepTemplateLogo;


// WEBPACK FOOTER //
// ./app/areas/projects/step-templates/step_template_logo.jsx